// The MIT License (MIT)
// 
// Copyright (c) 2015 angus croll
// 
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
// 
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
// 
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Plotter from '../lib/plotter';

// Based on https://github.com/angus-c/react-function-plot
class Plot extends Component {
  constructor(props) {
    super(props);
    this.plotSelector = ['.plot', this.props.className].join('.');
    this.plotter = new Plotter({selector: this.plotSelector, thickness: props.thickness});
  }

  componentDidMount() {
    this.plotter.addPath(this.props.fn);
  }

  componentDidUpdate() {
    this.plotter.updatePath(this.props.fn);
  }

  render() {
    const className = classnames('plot', this.props.className);
    return (
      <div className={className}/>
    );
  }
}

Plot.defaultProps = {
  className: '',
  fn: x => {},
  thickness: 4
}

Plot.propTypes = {
  className: PropTypes.string.isRequired,
  fn: PropTypes.func,
  thickness: PropTypes.number
}

export default Plot;
